import { uploadPresignedFile } from "@retro-ia/shared/upload";

/** Sube un logo de cliente final al bucket público y devuelve su referencia. */
export function subirLogoClienteFinal(file: File) {
  return uploadPresignedFile({
    file,
    ruta: "public/img/clientesFinales/" + file.name,
    fileName: file.name,
    fileType: file.type,
    isPublic: true,
  });
}
